<app-spinner *ngIf="submitted"></app-spinner>

<section class="login-page" [hidden]="submitted">
  <mat-card class="login-card" appearance="outlined">
    <mat-card-content>
      <div class="logo-mark" aria-hidden="true">
        <img routerLink="home"
             [ngSrc]="'https://kleksi.com/img/logo_kleksi_app_white.png'"
             height="20"
             width="85"
             alt="App Logo"
             class="logo-img insidemenu" />

      </div>

      <div class="login-copy">
        <p class="eyebrow" i18n>KLEKSI dashboard</p>
        <h1 i18n>Welkom terug</h1>
        @switch (notice()) {
          @case ('session-expired') {
            <p class="login-notice" role="status" aria-live="polite" i18n="@@session-expired">
              Uw sessie is verlopen. Log opnieuw in om verder te gaan.
            </p>
          }
          @case ('session-refresh-error') {
            <p class="login-notice login-notice-error" role="alert" i18n="@@session-refresh-error">
              Uw sessie kon niet worden vernieuwd. Log opnieuw in. Neem contact op met KLEKSI als dit blijft gebeuren.
            </p>
          }
          @case ('token-validation-error') {
            <p class="login-notice login-notice-error" role="alert" i18n="@@token-validation-error">
              Uw sessie kon niet worden gecontroleerd. Controleer de datum en tijd van dit apparaat en log opnieuw in.
            </p>
          }
        }
        <p i18n>
          Log in met je KLEKSI account. Je wordt doorgestuurd naar onze beveiligde aanmeldpagina.
        </p>
      </div>
    </mat-card-content>

    <mat-card-actions>
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="login-button"
        (click)="handleLoginBtn()"
        i18n
      >
        Login
      </button>
    </mat-card-actions>
  </mat-card>
</section>
